import React from 'react'

import './AlertModal.css'
import { useDisableBodyScroll } from '../../utils/useDisableBodyScroll'

export function AlertModal({ isOpen, title, message, handleClick, buttonLabel }) {

  useDisableBodyScroll(isOpen)

  return isOpen ? (
    <div className='alert-modal'>
      <div className='alert-modal-content'>
        <div className='alert-modal-content-title'>{title}</div>
        <div>{message}</div>
        <div className='alert-modal-content-actions'>
          <button onClick={handleClick} className='alert-modal-content-actions-button alert-modal-content-actions-button--cta'>{buttonLabel}</button>
        </div>
      </div>
    </div>
  ) : null
}

export function AlertModalWithActions({ isOpen, title, message, handleLeftClick, leftLabel, handleRightClick, rightLabel, }) {
  return isOpen ? (
    <div className='alert-modal'>
      <div className='alert-modal-content'>
        <div className='alert-modal-content-title'>{title}</div>
        {message && <div>{message}</div>}
        <div className='alert-modal-content-actions'>
          <button onClick={handleLeftClick} className='alert-modal-content-actions-button'>{leftLabel}</button>
          <button onClick={handleRightClick} className='alert-modal-content-actions-button alert-modal-content-actions-button--cta'>{rightLabel}</button>
        </div>
      </div>
    </div>
  ) : null
}
